import Vue from 'vue'
import _ from 'lodash'
import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import Grid from '@/components/DynamicComponents/Projects/NewConstruction/AddTile/Grid'
import { formatCurrency } from '@/services/convert'
import { costTypes } from '@/services/config'

export default {
  components: {
    'ag-grid-vue': Grid,
  },
  props: [
    'costDetails',
    'type',
    'dropdownData',
    'screenIndentifier',
    'sequence',
    'tiles',
    'takeoffs',
    'isParentLinked',
    'levelTiles',
    'childTiles',
    'isArchive',
  ],
  data() {
    return {
      columnDefs: [],
      loader: false,
      create: new Vue(),
      width: '110rem',
      height: '30rem',
      list: [],
      formatCurrency: formatCurrency,
      visible: false,
      isUpdate: false,
      levelTotal: 0,
      isAdjustmentTile: false,
      isAddTile: false,
      emptyImage: process.env.BASE_URL + 'resources/images/empty.png',
      padding: '0px',
      selectedKeys: [],
      selectedTiles: [],
      tileNames: [],
      isLevelValid: true,
      isTileValid: true,
    }
  },
  beforeMount() {
    this.loadingConfig()
    window.addEventListener('resize', this.detectViewPortListener)
  },
  created() {
    this.list = _.get(this.costDetails, 'tiles', [])
    this.list.forEach(element => {
      Object.assign(element, {
        tileTotal: element.takeoffs
          .filter(i => !i.isAdjustmentTakeoff)
          .reduce((total, takeoff) => {
            return total + (takeoff.unitCost ? takeoff.unitCost : 0)
          }, 0),

        adjustmentTileTotal: element.takeoffs
          .filter(i => i.isAdjustmentTakeoff)
          .reduce((total, takeoff) => {
            return total + (takeoff.unitCost ? takeoff.unitCost : 0)
          }, 0),
      })
    })
    this.levelTotal = _.get(this.costDetails, 'totalCost', 0)
    this.isLevelValid = this.costDetails.isValidTakeoff
    this.visible = true
    this.$root.$off('onLevelLinkTakeoff')
    this.$root.$on('onLevelLinkTakeoff', this.onLevelLinkTakeoff)
  },
  methods: {
    loadingConfig() {
      this.columnDefs = [
        {
          rowDrag: true,
          headerName: '',
          field: 'display',
          floatingFilter: false,
          width: 3,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          sortable: false,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: '',
          field: 'isValidTakeoff',
          floatingFilter: false,
          width: 3,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          sortable: false,
          pinned: 'left',
          menuTabs: [],
          cellRenderer: 'actionCellRenderer',
          cellRendererParams: {
            name: 'validTakeoff',
          },
        },
        {
          field: 'checkbox',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          filter: false,
          editable: false,
          width: 5,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          headerTooltip: 'ID',
          width: 60,
          wrapText: false,
          editable: false,
          filter: 'customFilter',
          resizable: true,
          cellRendererParams: {
            searchType: 'string',
          },
          cellRenderer: 'toolTipRenderer',
          cellStyle: { textAlign: 'left' },
          headerClass: 'header-left',
        },
        {
          headerName: 'Cost Type',
          field: 'costType',
          headerTooltip: 'Cost Type',
          cellEditor: 'selectEditor',
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'actualCostLevel',
            dropdownName: 'costType',
            dropdownData: this.dropdownData,
          },
          width: 150,
          wrapText: false,
          editable: !this.isArchive,
          filter: 'customFilter',
          resizable: true,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Cost Method',
          field: 'costMethod',
          headerTooltip: 'Cost Method',
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          width: 150,
          wrapText: false,
          editable: false,
          filter: 'customFilter',
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          hide: true,
        },
        {
          headerName: 'Contract',
          field: 'contract',
          headerTooltip: 'Contract',
          cellEditor: 'selectEditor',
          cellRendererParams: {
            type: 'actualCostLevel',
            dropdownName: 'contract',
            dropdownData: this.dropdownData,
            name: 'newContract',
          },
          width: 150,
          wrapText: false,
          filter: 'customFilter',
          editable: params => {
            return (
              !costTypes.includes(params.data.mCostTypeId) && !this.isArchive
            )
          },
          resizable: true,
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Cat Code',
          field: 'categoryCode',
          headerTooltip: 'Cat Code',
          cellEditor: 'selectEditor',
          cellRendererParams: {
            type: 'actualCostLevel',
            dropdownName: 'category',
            dropdownData: this.dropdownData,
          },
          width: 150,
          wrapText: false,
          editable: params => {
            return (
              !costTypes.includes(params.data.mCostTypeId) && !this.isArchive
            )
          },
          filter: 'customFilter',
          resizable: true,
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Description',
          field: 'takeoff',
          headerTooltip: 'Description',
          cellEditor: 'textEditor',
          cellRendererParams: {
            type: 'actualCostLevel',
            screen: 'Project',
            maxLength: 100,
          },
          width: 200,
          wrapText: false,
          filter: 'customFilter',
          resizable: true,
          editable: !this.isArchive,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Cost',
          field: 'unitCost',
          headerTooltip: 'Cost',
          cellEditor: 'inputNumberEditor',
          cellRenderer: 'costPriceCellRenderer',
          headerClass: 'header-right',
          cellRendererParams: {
            type: 'actualCostLevel',
            placeholder: 'Cost',
            precision: 2,
          },
          width: 100,
          wrapText: false,
          editable: params => {
            return !params.data.isAdjustmentTakeoff && !this.isArchive
          },
          filter: 'customFilter',
          resizable: true,
        },
        {
          headerName: 'Note',
          field: 'note',
          headerTooltip: 'Note',
          width: 200,
          wrapText: false,
          editable: !this.isArchive,
          filter: 'customFilter',
          cellEditor: 'textEditor',
          cellRendererParams: {
            type: 'actualCostLevel',
            placeholder: 'Note',
          },
          resizable: true,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Child Tile Name',
          field: 'tileName',
          headerTooltip: 'Child Tile Name',
          cellEditor: 'selectEditor',
          cellRendererParams: {
            type: 'actualCostLevel',
            dropdownName: 'tile',
            name: 'tile',
            dropdownData: Object.assign(this.dropdownData, { tile: this.tiles }),
          },
          width: 150,
          wrapText: false,
          resizable: true,
          editable: params => {
            return !params.data.isAdjustmentTakeoff && !this.isArchive
          },
          cellRenderer: 'toolTipRenderer',
          filter: 'customFilter',
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          cellRenderer: 'actionCellRenderer',
          cellRendererParams: {
            type: 'actualCostTile',
          },
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          floatingFilter: false,
          width: 100,
          resizable: false,
          suppressSizeToFit: true,
          headerTooltip: 'Action',
          pinned: 'right',
          menuTabs: [],
        },
      ]
    },

    handleOk() {},

    onUpdate(flag) {
      this.isUpdate = flag
    },

    handleCancel() {
      this.visible = false
      this.$root.$off('deleteRecord')
      this.$root.$off('handleTileChange')
      this.$root.$off('cloneTileTakeoff')
      this.$emit('closeTile', false, this.isUpdate)
    },

    onAddTile(flag) {
      this.loader = true
      const url = projectAPIs.project.asset.actualCost.level.tile.add(
        this.$route.params.id,
        this.costDetails.assetId,
        this.costDetails.id,
      )
      instance
        .post(url, { isAdjustmentTile: flag })
        .then(response => {
          Object.assign(response.data.result, {
            takeoffs: [],
          })
          this.list.push(response.data.result)
          this.loader = false
          this.isAddTile = false
          this.isAdjustmentTile = false
        })
        .catch(err => {
          this.loader = false
          errorService(err)
        })
    },

    deleteTile(tile) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${tile.tileName} ?`,
        content: h => (
          <div style="color:red;">
            <p>This action will delete all information related to level</p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmTileDelete(tile.id)
        },
        onCancel() {},
        class: 'test',
      })
    },

    confirmTileDelete(id) {
      this.loader = true
      instance
        .delete(
          `${projectAPIs.project.asset.actualCost.level.tile.delete(
            this.$route.params.id,
            this.costDetails.assetId,
            this.costDetails.id,
            id,
          )}`,
        )
        .then(response => {
          this.loader = false
          const index = this.list.findIndex(i => i.id === id)
          this.list.splice(index, 1)
          const tileIndex = this.levelTiles.findIndex(i => i.id === id)
          if (tileIndex > -1) {
            this.levelTiles.splice(tileIndex, 1)
          }
          this.levelTotal = 0
          this.levelTotal = this.list.reduce((total, tile) => {
            return total + (tile.tileTotal ? tile.tileTotal : 0)
          }, 0)
          this.isUpdate = true
        })
        .catch(err => {
          this.loader = false
          errorService(err)
        })
    },

    calculateTileTotal(
      data,
      total,
      adjustmentTotal,
      adjustmentTakeoff,
      isValid,
      tileId,
    ) {
      const list = [...this.list]
      const index = this.list.findIndex(i => i.id === tileId)
      if (index > -1) {
        list[index].tileTotal = total
        list[index].adjustmentTileTotal = adjustmentTotal
        list[index].takeoffs = data
        list[index].isValidTakeoff = isValid
        const isAdjustmentTakeoff = list[index].takeoffs.some(
          i => i.isAdjustmentTakeoff,
        )
        if (!isAdjustmentTakeoff && adjustmentTakeoff.length > 0) {
          list[index].takeoffs.push(adjustmentTakeoff[0])
        }
        this.list = list
        this.levelTotal = 0
        this.levelTotal = this.list.reduce((total, tile) => {
          return total + (tile.tileTotal ? tile.tileTotal : 0)
        }, 0)
      }
      this.isLevelValid = this.list.every(i => i.isValidTakeoff)
    },

    updateColumnDefs(record) {
      const columns = this.columnDefs
      if (record.isAdjustmentTile) {
        return columns.filter(i => i.field !== 'childTileId')
      } else {
        return columns
      }
    },

    detectViewPortListener() {
      if (window.innerWidth > 1450) {
        this.width = '110rem'
        this.padding = '0px !important'
      } else if (window.innerWidth < 1450) {
        this.width = '100%'
        this.padding = '10px !important'
      } else {
        this.width = '110rem'
        this.padding = '0px !important'
      }
    },

    onSelectedKeys(data, tileDetails) {
      this.selectedKeys = this.selectedKeys.filter(
        i => i.tileId !== tileDetails.id,
      )
      this.tileNames = this.tileNames.filter(i => i.id !== tileDetails.id)
      this.selectedKeys = [...this.selectedKeys, ...data]
      const tiles = this.selectedKeys.map(i => i.tileId)
      this.selectedTiles = [...new Set(tiles)]
      this.tileNames.push({
        id: tileDetails.id,
        tileName: tileDetails.tileName,
      })
    },

    linkTakeoffs(url, type, record, tileId, tileDetails, tileName) {
      const newData = [...this.list]
      let isValid = true
      const title = `You can't ${
        type === 'link' ? 'link' : 'move'
      } line item which is already linked to the tile on child level`
      const description = `Please unselect or unlink the above line items before  ${
        type === 'link' ? 'linking to child' : 'moving to other tile'
      }.`
      if (this.selectedKeys.length > 0) {
        const isLinked = this.selectedKeys.some(i => i.childTileId)
        var that = this
        if (isLinked) {
          isValid = false
          const h = this.$createElement
          this.$info({
            title: title,
            content: h('div', {}, [
              h(
                'div',
                { attrs: { class: 'linked-takeoff-div' } },
                that.showLinkedTakeoffs(h),
              ),
              h('p', { attrs: { class: 'warning-message' } }, description),
            ]),
            onOk() {},
          })
        } else {
          this.selectedKeys = this.selectedKeys.filter(
            i => i.levelId === tileDetails.levelId,
          )
        }
      } else if (record && record.childTileId) {
        isValid = false
        var self = this
        const h = this.$createElement
        this.$info({
          title: title,
          content: h('div', {}, [
            h(
              'div',
              { attrs: { class: 'linked-takeoff-div' } },
              self.showLinkedTakeoff(h, [record], tileDetails),
            ),
            h('p', { attrs: { class: 'warning-message' } }, description),
          ]),
          onOk() {},
        })
      } else if (!record) {
        isValid = false
        const h = this.$createElement
        this.$info({
          title: 'Move Takeoffs',
          content: h('div', {}, [
            h(
              'p',
              { attrs: { class: 'warning-message' } },
              `Please select atleast one line item to ${
                type === 'link' ? 'link' : 'move'
              }`,
            ),
          ]),
          onOk() {},
        })
      }
      if (isValid) {
        let ids = this.selectedKeys.length > 0 ? this.selectedKeys : [record]
        ids = _.sortBy(ids, ['id'])
        let request = []
        switch (type) {
          case 'new':
          case 'existing':
            request = ids.map(i => i.id)
            break

          default:
            ids.forEach(element => {
              request.push({
                id: element.id,
                childTileId: tileId,
              })
            })
            break
        }

        this.loader = true
        this.moveTakeoff = true
        instance
          .patch(url, request)
          .then(response => {
            switch (type) {
              case 'new':
                newData.map(tile => {
                  const takeoffs = [...tile.takeoffs]
                  tile.takeoffs = []
                  ids.forEach(element => {
                    const index = takeoffs.findIndex(i => i.id === element.id)

                    if (index > -1) {
                      takeoffs.splice(index, 1)
                    }
                  })
                  tile.tileTotal = takeoffs
                    .filter(i => !i.isAdjustmentTakeoff)
                    .reduce((total, takeoff) => {
                      return total + (takeoff.unitCost ? takeoff.unitCost : 0)
                    }, 0)
                  tile.adjustmentTileTotal = takeoffs
                    .filter(i => i.isAdjustmentTakeoff)
                    .reduce((total, takeoff) => {
                      return total + (takeoff.unitCost ? takeoff.unitCost : 0)
                    }, 0)
                  const isPresent = takeoffs.some(i => !i.isAdjustmentTakeoff)
                  tile.tileTotal = takeoffs
                    .filter(i => !i.isAdjustmentTakeoff)
                    .reduce((total, takeoff) => {
                      return total + (takeoff.unitCost ? takeoff.unitCost : 0)
                    }, 0)
                  tile.adjustmentTileTotal = takeoffs
                    .filter(i => i.isAdjustmentTakeoff)
                    .reduce((total, takeoff) => {
                      return total + (takeoff.unitCost ? takeoff.unitCost : 0)
                    }, 0)
                  const index = takeoffs.findIndex(i => i.isAdjustmentTakeoff)
                  if (index > -1) {
                    takeoffs[index].unitCost = !isPresent
                      ? 0
                      : 0 - tile.tileTotal
                    takeoffs[index].totalPrice = !isPresent
                      ? 0
                      : 0 - tile.tileTotal
                  }
                  tile.takeoffs = [...takeoffs]
                  tile.isValidTakeoff = !takeoffs.some(
                    i =>
                      !i.isAdjustmentTakeoff &&
                      typeof i.isValidTakeoff !== 'undefined' &&
                      !i.isValidTakeoff,
                  )
                })
                break
              case 'existing':
                newData.map(tile => {
                  const takeoffs = [...tile.takeoffs]
                  tile.takeoffs = []
                  ids.forEach(element => {
                    const index = takeoffs.findIndex(i => i.id === element.id)

                    if (index > -1) {
                      takeoffs.splice(index, 1)
                    }
                  })
                  const isPresent = takeoffs.some(i => !i.isAdjustmentTakeoff)
                  tile.tileTotal = takeoffs
                    .filter(i => !i.isAdjustmentTakeoff)
                    .reduce((total, takeoff) => {
                      return total + (takeoff.unitCost ? takeoff.unitCost : 0)
                    }, 0)
                  tile.adjustmentTileTotal = takeoffs
                    .filter(i => i.isAdjustmentTakeoff)
                    .reduce((total, takeoff) => {
                      return total + (takeoff.unitCost ? takeoff.unitCost : 0)
                    }, 0)
                  const index = takeoffs.findIndex(i => i.isAdjustmentTakeoff)
                  if (index > -1) {
                    takeoffs[index].unitCost = !isPresent
                      ? 0
                      : 0 - tile.tileTotal
                    takeoffs[index].totalPrice = !isPresent
                      ? 0
                      : 0 - tile.tileTotal
                  }
                  tile.takeoffs = [...takeoffs]
                  tile.isValidTakeoff = !takeoffs.some(
                    i =>
                      typeof i.isValidTakeoff !== 'undefined' &&
                      !i.isValidTakeoff,
                  )
                })

                const tileIndex = newData.findIndex(i => i.id === tileId)

                if (tileIndex > -1) {
                  const takeoffs = [...newData[tileIndex].takeoffs]
                  newData[tileIndex].takeoffs = []
                  ids.forEach(element => {
                    element.tileId = tileId
                    takeoffs.push(element)
                  })
                  const tileTotal = takeoffs
                    .filter(i => !i.isAdjustmentTakeoff)
                    .reduce((total, takeoff) => {
                      return total + (takeoff.unitCost ? takeoff.unitCost : 0)
                    }, 0)
                  const index = takeoffs.findIndex(i => i.isAdjustmentTakeoff)
                  if (index > -1) {
                    takeoffs[index].unitCost = 0 - tileTotal
                    takeoffs[index].totalPrice = 0 - tileTotal
                  }
                  newData[tileIndex].takeoffs = [...takeoffs]
                  newData[tileIndex].isValidTakeoff = !takeoffs.some(
                    i =>
                      typeof i.isValidTakeoff !== 'undefined' &&
                      !i.isValidTakeoff,
                  )
                  newData[tileIndex].tileTotal = takeoffs
                    .filter(i => !i.isAdjustmentTakeoff)
                    .reduce((total, takeoff) => {
                      return total + (takeoff.unitCost ? takeoff.unitCost : 0)
                    }, 0)
                  newData[tileIndex].adjustmentTileTotal = takeoffs
                    .filter(i => i.isAdjustmentTakeoff)
                    .reduce((total, takeoff) => {
                      return total + (takeoff.unitCost ? takeoff.unitCost : 0)
                    }, 0)
                }
                break

              default:
                newData.map(tile => {
                  const takeoffs = [...tile.takeoffs]
                  tile.takeoffs = []
                  ids.forEach(element => {
                    const index = takeoffs.findIndex(i => i.id === element.id)

                    if (index > -1) {
                      takeoffs[index].childTileId = tileId
                      takeoffs[index].tileName = tileName
                    }
                  })
                  tile.takeoffs = [...takeoffs]
                })
                this.loader = false
                break
            }
            this.selectedKeys = []
            this.selectedTiles = []
            this.tileNames = []
            this.list = [...newData]
            this.isUpdate = true
          })
          .catch(err => {
            this.loader = false
            this.moveTakeoff = false
            errorService(err)
          })
      }
    },

    showLinkedTakeoffs(h) {
      const row = []
      this.selectedKeys
        .filter(i => i.childTileId)
        .forEach(element => {
          let tile = this.tileNames.find(i => i.id === element.tileId)
          tile = tile ? `${tile.tileName} - ` : ''
          row.push(
            h(
              'p',
              { attrs: { class: 'linked-takeoff' } },
              `${tile} ${element.takeoff}`,
            ),
          )
        })
      return row
    },

    showLinkedTakeoff(h, data, tileDetails) {
      const row = []
      data
        .filter(i => i.childTileId)
        .forEach(element => {
          row.push(
            h(
              'p',
              { attrs: { class: 'linked-takeoff' } },
              `${tileDetails.tileName} ${element.takeoff}`,
            ),
          )
        })
      return row
    },

    onLevelLinkTakeoff(data) {
      this.newTiles = []
      if (data.Result) {
        const isPresent = this.levelTiles.some(i => i.id === data.Result.Id)
        if (!isPresent) {
          this.levelTiles.push({
            assetId: data.Result.AssetId,
            id: data.Result.Id,
            isAdjustmentTile: data.Result.IsAdjustmentTile,
            isLinked: data.Result.IsLinked,
            levelId: data.Result.LevelId,
            projectId: data.Result.ProjectId,
            sequence: data.Result.Sequence,
            tileName: data.Result.TileName,
          })
        }
        if (data.Result.AssetId === this.costDetails.assetId) {
          this.getData(data.Result.Id)
        }
      } else {
        this.loader = false
      }
    },

    getData(id) {
      this.loader = true
      this.moveTakeoff = false
      this.loading = false
      instance
        .get(
          projectAPIs.project.asset.actualCost.level.list(
            this.$route.params.id,
            this.costDetails.assetId,
          ),
        )
        .then(response => {
          const list = [...this.list]
          const data = _.get(response.data, 'result', [])
          const level = data.find(i => i.id === this.costDetails.id)
          if (level) {
            const tile = level.tiles.find(i => i.id === id)
            const isPresent = list.some(i => i.id === id)
            if (tile && !isPresent) {
              Object.assign(tile, {
                tileTotal: tile.takeoffs
                  .filter(i => !i.isAdjustmentTakeoff)
                  .reduce((total, takeoff) => {
                    return total + (takeoff.unitCost ? takeoff.unitCost : 0)
                  }, 0),

                adjustmentTileTotal: tile.takeoffs
                  .filter(i => i.isAdjustmentTakeoff)
                  .reduce((total, takeoff) => {
                    return total + (takeoff.unitCost ? takeoff.unitCost : 0)
                  }, 0),
              })
              list.push(tile)
            }
          }
          this.list = [...list]
          this.loader = false
        })
        .catch(error => {
          this.loader = false
          errorService(error)
        })
    },
  },
}
